import { shopOperationError } from "./shopLabels";
import React, { useEffect, useState, useRef } from 'react';
import { isAuthenticated, addFollowUserShop } from '../auth';
import { getShopFollowStatus } from '../auth/apiShops';
import { elakayAutoText as text } from '../pageInside/dataElakay';
export default function FollowShopButton({ ownerId, shopId, token }) {
 const [state,setState]=useState(null),[busy,setBusy]=useState(false),[error,setError]=useState('');
 const auth=isAuthenticated();
 const actionKey = `${shopId}:${token || ""}`;
 const latestShop=useRef(actionKey); latestShop.current=actionKey;
 useEffect(()=>{
  let canceled=false;setState(null);setError('');setBusy(false);
  if (shopId && token) getShopFollowStatus(shopId).then((data)=>{if(!canceled)setState(data);}).catch((failure)=>{if(!canceled)setError(shopOperationError(failure));});
  return()=>{canceled=true;};
 },[shopId,token]);
 if (!shopId || !token || String(auth?.user?._id)===String(ownerId)) return null;
 const toggle=async()=>{
  setBusy(true);setError('');
  try {
   const data=await addFollowUserShop(token,ownerId,shopId,!state.following);
   if(data?.error)throw Object.assign(Error(data.error), { code: data.code });
   if (latestShop.current===actionKey) setState({following:!state.following,followers:data.shopFollowerCount});
  }catch(failure){if (latestShop.current===actionKey) setError(shopOperationError(failure));}finally{if (latestShop.current===actionKey) setBusy(false);}
 };
 return <div>
  <button className="msh-action" disabled={busy || !state} aria-pressed={Boolean(state?.following)} onClick={toggle}>{text(state?.following?'h_msl_unfollow':'h_msl_follow',state?.following?'Unfollow Shop':'Follow Shop')}</button>
  {state && <span>{text('h_msl_followers','{count} followers',{count:state.followers})}</span>}
  {error && <div role="alert">{error}</div>}
 </div>;
}
